import { IconNames } from 'atoms/Icon'

export const FALLBACK_IMAGES_THEME = {
  DEFAULT: IconNames.discoverySolid,
  SECONDARY: IconNames.discovery,
  AVATAR: IconNames.user,
}
